import React, { Component, Suspense } from 'react';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import './App.css';
import {Route} from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import Contacts from "./components/Contacts";
import Collections from "./components/Collections";
import CollectionDetails from "./components/CollectionDetails";
import Show from './components/Show';
import Demo from './components/Demo'
import Designer from './components/Designer';
import Atelier from './components/Atelier';
import './i18n';


function Page() {
    const { t, i18n } = useTranslation();
    return(
        <Layout>
            <Route exact path='/' component={Home}/>
            <Route exact path='/contacts' component={Contacts}/>
            <Route exact path='/collections' component={Collections}/>
            <Route exact path='/collections/:name' component={CollectionDetails}/>
            <Route exact path='/atelier' component={Atelier}/>
            <Route exact path='/designer' component={Designer}/>
            <Route exact path='/show' component={Show}/>
            <Route exact path='/demo' component={Demo} message='hello man'/>
        </Layout>
    );
};
// here app catches the suspense from page in case translations are not yet loaded
export default function App() {
    return (
        <Suspense fallback={""}>
            <Page />
        </Suspense>
    );
}



// WEBPACK FOOTER //
// ./src/App.js